import styled from "styled-components";

const ExternalLink = styled.a`
  color: var(--link-color);
  text-decoration: none;
  border-bottom: 2px solid transparent;
  transition: all 0.1s ease;
  display: inline-block;
  padding-bottom: 0.1em;
  &:hover,
  &:focus {
    border-bottom: 2px solid var(--link-color);
  }
`;

export default ExternalLink;



// WEBPACK FOOTER //
// ./src/components/ExternalLink/index.js